import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Box, Input, Alert
} from "@mui/material";
import { sendNotification } from "../../../../Services/NotificationApi";

const SendNotificationDialog = ({ open, onClose, tenant, onSuccess }) => {
  const [form, setForm] = useState({
    tenant: tenant || "",
    title: "",
    message: "",
    file: null,
  });
  const [submitting, setSubmitting] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  // تحديث قيمة الحقول
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "file") {
      setForm((prev) => ({ ...prev, file: files[0] }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  // عند الإرسال
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSubmitting(true);
//     setSuccessMsg("");
//     setErrorMsg("");
//     try {
//       await sendNotification(form);
//       setSuccessMsg("تم إرسال التنبيه بنجاح");
//       if (onSuccess) onSuccess();
//       // إعادة تعيين الحقول بعد النجاح
//       setForm({
//         tenant: tenant || "",
//         title: "",
//         message: "",
//         file: null,
//       });
//     } catch (err) {
//       setErrorMsg("حدث خطأ أثناء إرسال التنبيه");
//     }
//     setSubmitting(false);
//   };
const handleSubmit = async (e) => {
  e.preventDefault();
  setSubmitting(true);
  setSuccessMsg("");
  setErrorMsg("");
  try {
    const formData = new FormData();
    formData.append("tenant", form.tenant);
    formData.append("title", form.title);
    formData.append("message", form.message);
    if (form.file) {
      formData.append("file", form.file);
    }

await sendNotification(form);

    setSuccessMsg("تم إرسال التنبيه بنجاح");
    if (onSuccess) onSuccess();
    setForm({
      tenant: tenant || "",
      title: "",
      message: "",
      file: null,
    });
  } catch (err) {
    setErrorMsg("حدث خطأ أثناء إرسال التنبيه");
  }
  setSubmitting(false);
};


  // تحديث قيمة tenant عند تغيير prop
  React.useEffect(() => {
    setForm((prev) => ({ ...prev, tenant: tenant || "" }));
  }, [tenant]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>إرسال تنبيه للعميل</DialogTitle>
      <DialogContent>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            label="المستأجر (tenant)"
            name="tenant"
            value={form.tenant}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
            disabled
          />
          <TextField
            label="عنوان التنبيه"
            name="title"
            value={form.title}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
          />
          <TextField
            label="محتوى التنبيه"
            name="message"
            value={form.message}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
            multiline
            rows={3}
          />
          <Input
            type="file"
            name="file"
            onChange={handleChange}
            fullWidth
            sx={{ mt: 2 }}
          />
          {successMsg && <Alert severity="success" sx={{ mt: 2 }}>{successMsg}</Alert>}
          {errorMsg && <Alert severity="error" sx={{ mt: 2 }}>{errorMsg}</Alert>}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>إلغاء</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={submitting}
        >
          إرسال
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendNotificationDialog;
